import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { glassCard, TEXT_PRIMARY, TEXT_SECONDARY, noMotion } from '../../designsystem/tokens';

const LiveTranscript = ({ text, isConfirmed }) => {
    const { t } = useTranslation();
    if (!text) return null;

    return (
        <Fade in={!!text}>
            <Box
                data-testid="live-transcript"
                role="region"
                aria-label={t('liveTranscript')}
                sx={{
                    ...glassCard,
                    p: 1.5,
                    maxHeight: 120,
                    overflowY: 'auto',
                    width: '90%',
                    maxWidth: 400,
                    backgroundColor: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    mt: 2,
                }}
            >
                <Typography
                    variant="body2"
                    aria-live="polite"
                    aria-atomic="true"
                    sx={{
                        color: isConfirmed ? TEXT_PRIMARY : TEXT_SECONDARY,
                        fontSize: '0.85rem',
                        lineHeight: 1.5,
                        fontStyle: isConfirmed ? 'normal' : 'italic',
                        transition: 'color 200ms ease-out',
                        ...noMotion,
                    }}
                >
                    {text}
                    {!isConfirmed && (
                        <Box
                            component="span"
                            sx={{
                                display: 'inline-block',
                                width: 2,
                                height: '1em',
                                backgroundColor: TEXT_SECONDARY,
                                ml: 0.5,
                                verticalAlign: 'middle',
                                animation: 'blink 1s step-end infinite',
                                '@keyframes blink': {
                                    '50%': { opacity: 0 },
                                },
                                '@media (prefers-reduced-motion: reduce)': {
                                    animation: 'none',
                                },
                            }}
                        />
                    )}
                </Typography>
            </Box>
        </Fade>
    );
};

export default LiveTranscript;
